import { useState, useEffect } from "react";
import useStateMachineWrapper from "../helpers/useStateMachineWrapper";
import useCalculators from "../helpers/useCalculators";
import { displayCost } from "../helpers/strings";

const CartDetails = (props) => {
  const {actions, state, sendState} = useStateMachineWrapper();
  const {getCartItems, getSubtotal} = useCalculators();

  return (<>
        <table className="table-auto w-full">
          <tbody className="divide-y">
            {getCartItems().map((i,k) => {
              // hide the discount all together if it's a freebie
              if(i.discount === true && parseFloat(i.amount) == 0) {
                {/* return null; */}
              }
              if(!i.name){
                return null;
              }
              //console.log('name', i.name);
              const isDiscount = i.discount === true;// && parseFloat(i.amount) != 0;
              const isPerMonth = parseFloat(i.amount) != 0;
              const isFree = parseFloat(i.amount) == 0;
              {/* let cost = displayCost(i.amount); */}

              return (
                <tr key={k} className={isDiscount ? 'italic font-bold' : ''}>
                    <td className="px-6 py-4 text-left">
                    {isDiscount && <span className="inline-block px-1 py-0.5 mr-2 bg-purple text-white shadow rounded text-xs relative -top-[1px]">PROMO</span>}
                    {i.name}</td>
                    <td className="px-6 py-4 text-right">{displayCost(i.amount, isPerMonth, isFree/*, !isDiscount, 'INCLUDED'*/)}</td>
                </tr>

            )})}
          </tbody>
          <tfoot className="border-t-[1px]">
            <tr>
              <th className="px-6 py-4 font-bold text-left">Total{state.session.isPreorder && ' Due Prior to Installation'}</th>
              <th className="px-6 py-4 font-bold text-right">${getSubtotal()}</th>
            </tr>
          </tfoot>
        </table>
    </>)

};

export default CartDetails;
